<template>
<section class="payment-info">
  <div class="definitions-list">
    <definition v-for="definition in definitions"
                :key="definition.key"
                :title="definition.title"
    >
      <div v-html="definition.content"></div>
    </definition>
  </div>
</section>
</template>

<script>
import { mapGetters } from 'vuex'
import HasDefinitions from '@/mixins/HasDefinitions'
import Definition from '@/components/lists/Definition'

export default {
  components: {
    Definition,
  },

  mixins: [
    HasDefinitions,
  ],

  computed: {
    ...mapGetters({
      settings: 'settings/deliveryPaymentsPayments',
    }),
  },
}
</script>
